<form novalidate role="form" aria-label="Sign In Form" [formGroup]="form" (submit)="hasTwoFactor ? loginWithOtp() : login()">
  @if (!hasTwoFactor) {
    <ix-input
      formControlName="username"
      autocomplete="username"
      name="username"
      class="username-input"
      [prefixIcon]="tnIconMarker('account', 'mdi')"
      [label]="'Username' | translate"
    ></ix-input>

    <ix-input
      formControlName="password"
      type="password"
      name="password"
      autocomplete="current-password"
      [prefixIcon]="tnIconMarker('lock', 'mdi')"
      [label]="'Password' | translate"
    ></ix-input>

    @if (showSecurityWarning) {
      <ix-insecure-connection></ix-insecure-connection>
    }

    <button
      class="submit-button"
      mat-button
      type="submit"
      color="primary"
      ixTest="log-in"
      [disabled]="isFormDisabled()"
    >
      {{ 'Log In' | translate }}
    </button>
    @if (isLastLoginAttemptFailed) {
      <div class="error">
        <p [innerHTML]="lastLoginError"></p>
      </div>
    }
  }
  @if (hasTwoFactor) {
    <p>
      {{ '2FA has been configured for this account. Enter the OTP to continue.' | translate }}
    </p>

    <ix-input
      formControlName="otp"
      autocomplete="one-time-code"
      [prefixIcon]="tnIconMarker('cellphone-link', 'mdi')"
      [label]="'Two-Factor Authentication Code' | translate"
      [required]="true"
    ></ix-input>

    @if (showSecurityWarning) {
      <ix-insecure-connection></ix-insecure-connection>
    }

    <div>
      <button
        class="submit-button"
        mat-button
        type="submit"
        color="primary"
        ixTest="log-in"
        [disabled]="isFormDisabled()"
      >
        {{ 'Proceed' | translate }}
      </button>
      <button
        class="submit-button"
        mat-button
        type="button"
        ixTest="otp-log-in"
        [disabled]="isFormDisabled()"
        (click)="cancelOtpLogin()"
      >{{ 'Cancel' | translate }}</button>
    </div>

    @if (isLastOtpAttemptFailed) {
      <div class="error">
        <p>{{ lastLoginError }}</p>
      </div>
    }
  }
</form>
